import { render, staticRenderFns } from "./ClaimEdit.vue?vue&type=template&id=21e2674f&scoped=true&"
import script from "./ClaimEdit.vue?vue&type=script&lang=js&"
export * from "./ClaimEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e2674f",
  null
  
)

export default component.exports